import { type SDK_WriteUserRecordMutationVariables, clientConfig, getSdk } from "@quickpoint.me/shared";
import rybbit from "@rybbit/js";
import { GraphQLClient } from "graphql-request";
import { nanoid } from "nanoid";

export const uploadRecord = async (value: string) => {
    const record: SDK_WriteUserRecordMutationVariables = {
        created: Date.now(),
        id: nanoid(26),
        stackId: "register",
        recordType: "email",
        stack: "quickpoint/landing",
        value,
    };


    const client = new GraphQLClient(clientConfig.gqlWriteUserRecord());
    const sdk = getSdk(client);
    try {
        await sdk.WriteUserRecord(record);
        const queryString = sessionStorage.getItem("queryString");
        if (queryString) {
            //in the query string replace utm_medium value with "signup"
            const newQueryString = queryString.replace(/utm_medium=[^&]*/, "utm_medium=signup");
            const newUrl = `${window.location.origin}${window.location.pathname}${newQueryString}`;
            rybbit.pageview(newUrl);
            sessionStorage.removeItem("queryString");
        }

        return true
    } catch (e) {
        console.log(e)
        return false
    }
};